import script from "./ScheduleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleComponent.vue?vue&type=style&index=0&id=1b7da571&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7da571"]])

export default __exports__